import React, { useContext } from "react";
import { surveyService } from "../../services/survey.service"
import { Skeleton,Table } from "antd";

const UserActivityLogInformation = (props) => {
  const [dataSource, setDataSource] = React.useState([])
  
  const getData = async () =>{
    let userActivityLogInformation= await surveyService.getLogging()
    let dataSource=userActivityLogInformation.map(item=>
      ({
        id:item.id,
        activityType:item.request&&item.request.IDuser&&'Nova registracija'||item.details=='getToken'&&'Novi anonimni korisnik'||'Prijava u sustava',
        loginMail:item.request&&item.request.email||'',
        loginResult:item.request&&item.request.IDuser&&item.response&&item.response.status==200&&'Uspješna registracija'||item.response&&item.response.status==200&&'Uspješna prijava'||item.response&&item.response.response=='User not found!'&&'Neuspješna prijava',
        userType:!item.request&&"Stanovnik"||item.response&&item.response.response.jls_affiliation==''&&'Gospodarski subjekt'||(item.response&&item.response.response.name=='grad'||item.response&&item.response.response.name=='opcina'||item.response&&item.response.response.jls_affiliation)&&'Jedinica lokalne samouprave'||item.response&&item.response.response=='User not found!'&&'Neuspješna prijava'||item.response&&item.response.response.jls_affiliation==null&&'Gospodarski subjekt',
        userAffiliation:item.response&&item.response.response.jls_affiliation||(item.response&&item.response.response.name=='grad'||item.response&&item.response.response.name=='opcina')&&item.response&&item.response.response.surname||'',
        loginTime:(item.created.split('T')[1].split(':')[0]==0&&'23'||item.created.split('T')[1].split(':')[0]-1)+":"+item.created.split('T')[1].split(':')[1]+":"+item.created.split('T')[1].split(':')[2].split('.')[0],
        loginDate:item.created.split('T')[0].split('-')[2]+'.'+item.created.split('T')[0].split('-')[1]+'.'+item.created.split('T')[0].split('-')[0]+'.'
      })    
      
      )
      setDataSource(dataSource)
}

const columns = [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
    sorter: (a, b) => a.id-b.id
  },
  {
    title: 'Vrsta aktivnosti',
    dataIndex: 'activityType',
    key: 'activityType',
    sorter: (a, b) => a.activityType?.localeCompare(b.activityType),
    filters:[
      {
        text: 'Prijava u sustava',
        value: 'Prijava u sustava',
      },
      {
        text: 'Novi anonimni korisnik',
        value: 'Novi anonimni korisnik',
      },
      {
        text: 'Nova registracija',
        value: 'Nova registracija',
      },
    ],
    onFilter: (value, record) => record.activityType?.indexOf(value) === 0,
  },
  {
    title: 'E-mail prijave',
    dataIndex: 'loginMail',
    key: 'loginMail',
  },
  {
    title: 'Status prijave',
    dataIndex: 'loginResult',
    key: 'loginResult',
  },
  {
    title: 'Tip prijavitelja',
    dataIndex: 'userType',
    key: 'userType',
    sorter: (a, b) => a.userType?.localeCompare(b.userType),
    filters:[
      {
        text: 'Gospodarski subjekt',
        value: 'Gospodarski subjekt',
      },
      {
        text: 'Neuspješna prijava',
        value: 'Neuspješna prijava',
      },
      {
        text: 'Stanovnik',
        value: 'Stanovnik',
      },
      {
        text: 'Jedinica lokalne samouprave',
        value: 'Jedinica lokalne samouprave',
      },
    ],
    onFilter: (value, record) => record.userType?.indexOf(value) === 0,
  },
  {
    title: 'Pripadnost jls-u',
    dataIndex: 'userAffiliation',
    key: 'userAffiliation',
  },
  {
    title: 'Vrijeme prijave',
    dataIndex: 'loginTime',
    key: 'loginTime',
  },
  {
    title: 'Datum prijave',
    dataIndex: 'loginDate',
    key: 'loginDate',
  },
];
React.useEffect(() => {
  const fetchData = async () => {
     await Promise.all([getData()]);
  }  
  fetchData();
},[])


    return (
    <>      
    {dataSource&&<Table dataSource={dataSource} columns={columns} />}
</>

    )
}

export default UserActivityLogInformation;